export const MOBILE_WIDTH = 500;